import React, { useState, Fragment, useEffect } from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
  useLocation,
} from "react-router-dom";
import { useSelector } from "react-redux";

import AccessibleNavigationAnnouncer from "./Components/AccessibleNavigationAnnouncer";
import ActiveUsers from "./Components/ActiveUsers";
import Login from "./Components/Login";
import CreateAccount from "./Components/CreateAccount";
import UserProfile from "./Components/UserProfile";
import Setup from "./Components/Setup";
import Priorities from "./Components/Priorities";
import SideBar from "./Components/SideBar";
import UserManagement from "./Components/UserManagement";
import OrganizationSettings from "./Components/OrganizationSettings";
import ResetPassword from "./Components/ResetPassword";
import Reports from "./Components/Reports";
import Dashboard from "./Components/Dashboard";
import GeneralReport from "./Components/GeneralReport";
import Conversations from "./Components/Conversation/Conversations";
import Organizations from "./Components/Organizations";
import CustomNotifications from "./Components/CustomNotifications";
import ResetPasswordAdmin from "./Components/User/ResetPasswordAdmin";
import MoodReminders from "./Components/CreateNotifications";

const publicRoutes = [
  { pathname: "/login", path: "/login", component: Login },
  {
    pathname: "/reset_password",
    path: "/reset_password",
    component: ResetPassword,
  },
  {
    pathname: "/create_account",
    path: "/create_account",
    component: CreateAccount,
  },
];

const privateRoutes = [
  {
    pathname: "/user_management",
    path: "/user_management",
    component: UserManagement,
  },
  { pathname: "/dashboard", path: "/dashboard", component: Dashboard },
  {
    pathname: "/management/",
    path: "/management/:status",
    component: ActiveUsers,
  },
  // {
  //   pathname: "/management/archive",
  //   path: "/management/archive",
  //   component: UserManagement,
  // },
  {
    pathname: "/reports",
    path: "/reports",
    component: Reports,
  },
  { pathname: "/setup", path: "/setup", component: Setup },
  { pathname: "/priorities", path: "/priorities", component: Priorities },
  {
    pathname: "/general_report",
    path: "/general_report",
    component: GeneralReport,
  },
  {
    pathname: "/organization_settings",
    path: "/organization_settings",
    component: OrganizationSettings,
  },
  {
    pathname: "/organizations",
    path: "/organizations",
    component: Organizations,
  },
  {
    pathname: "/notifications/custom",
    path: "/notifications/custom",
    component: CustomNotifications,
  },
  {
    pathname: "/notifications/reminders",
    path: "/notifications/reminders",
    component: MoodReminders,
  },
  {
    pathname: "/conversations/status/",
    path: "/conversations/status/:status",
    component: Conversations,
  },
  {
    pathname: "/conversations",
    path: "/conversations/:id",
    component: Conversations,
  },
  {
    pathname: "/users",
    path: "/users/:id",
    component: UserProfile,
  },
  {
    pathname: "/reset_password_admin",
    path: "/reset_password_admin/:_id",
    component: ResetPasswordAdmin,
  },
  {
    pathname: "/reset_password",
    path: "/reset_password",
    component: ResetPassword,
  },
];

const Routes = (props) => {
  const user = useSelector((state) => state.user.user);
  const organization = useSelector((state) => state.user.organization);
  const pathname = useLocation().pathname;

  return user === null ? (
    <Fragment>
      {publicRoutes.map((route) => (
        <Route exact path={route.path} component={route.component} />
      ))}
      {publicRoutes.filter((r) => pathname.includes(r.pathname)).length ===
      0 ? (
        <Redirect to="/login" />
      ) : null}
    </Fragment>
  ) : (
    <Fragment>
      <SideBar />
      {privateRoutes.map((route) => (
        <Route exact path={route.path} component={route.component} />
      ))}
      {privateRoutes.filter((r) => pathname.includes(r.pathname)).length ===
      0 ? (
        user.isNotSetup ? (
          <Redirect to="/setup" />
        ) : (
          <Redirect to="/dashboard" />
        )
      ) : null}
    </Fragment>
  );
};

const App = (props) => {
  return (
    <Router>
      <div id="root" className="flex flex-col md:flex-row h-screen">
        <AccessibleNavigationAnnouncer />
        <Switch>
          <Routes />
        </Switch>
      </div>
    </Router>
  );
};
export default App;
